<template>
  <div class="animated fadeIn">

  <!-- <b-btn v-b-toggle.collapse1 variant="primary" style="margin-top:10px">Create New Campaign</b-btn>
      <b-collapse id="collapse1" class="mt-2"> -->
        <!-- <b-card> -->
          <!-- <form> -->
            <div class="form-row">
              <div class="form-group col-md-8">
                <label for="campaignNameInput" class="col-form-label">*Name:</label>
                <input type="text" class="form-control" id="campaignNameInput" placeholder="Enter Name"
                  v-model="name" required>
              </div>
              <div class="form-group">
                <label for="isDemo" class="col-form-label">Is Demo:</label>
                <input type="checkbox" class="form-control" id="isDemo" placeholder="Is Demo"
                  v-model="isDemo">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="campaignDescInput" class="col-form-label">*Description:</label>
                <input type="text" class="form-control" id="campaignDescInput" placeholder="Enter Description"
                  v-model="description" required>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="campaignBannerInput" class="col-form-label">Campaign Banner:</label>
                <input type="file" class="form-control" id="campaignBannerInput" accept="image/*"
                  @change="campaignBannerChanged($event.target.files)">
                <small class="form-text text-muted">Optional. This image will be shown on the mobile campaign card.</small>
              </div>
            </div>

            <b-card>
              <p><b>Reward Pool</b></p>
              <p class="text-muted">Add each reward that can be won. Cash value is optional and used only for reporting totals.</p>
              <div class="form-row">
                <div class="form-group">
                  <button type="button" class="btn btn-primary" @click="addCustomNote()">Add Reward</button>
                </div>
              </div>

              <div class="form-row" v-for="(item, index) of customRMAmount" v-bind:key="index">
                <div class="form-group col-md-4">
                  <label class="col-form-label">*Reward Name / Amount:</label>
                  <input type="text" class="form-control" placeholder="RM 10, Free lenses, Sensity voucher"
                    v-model="item.rewardLabel" v-on:keyup="updatedCustomNote">
                </div>
                <div class="form-group col-md-3">
                  <label class="col-form-label">Reward Type:</label>
                  <select class="form-control" v-model="item.rewardType" v-on:change="updatedCustomNote">
                    <option value="MONEY">Money</option>
                    <option value="VOUCHER">Voucher</option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <label class="col-form-label">Cash Value (MYR):</label>
                  <input type="number" class="form-control" placeholder="0"
                    v-model="item.rewardValue" v-on:keyup="updatedCustomNote" min="0">
                </div>
                <div class="form-group col-md-2">
                  <label class="col-form-label">*Quantity:</label>
                  <input type="number" class="form-control" id="item.noteAmount" placeholder="How many?"
                    v-model="item.totalQuantity" v-on:keyup="updatedCustomNote" min="0">
                </div>
                <div class="form-group col-md-1">
                  <label class="col-form-label">&nbsp;</label>
                  <button type="button" class="btn btn-danger form-control" @click="removeCustomNote(index)">Remove</button>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="col-form-label"><b>Monetary Summary: RM {{sumOfAllNotes}}</b></label>
                </div>
              </div>
            </b-card>
            
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="campaignStartDateInput" class="col-form-label">*Campaign Start Date:</label>
                <DateTimePicker format="DD/MM/YYYY h:i:s" id="campaignStartDateInput" v-on:update:date-value="updateCampaignStartDate"
                  />
              </div>
              <div class="form-group col-md-6">
                <label for="campaignEndDateInput" class="col-form-label">*Campaign End Date:</label>
                <DateTimePicker format="DD/MM/YYYY h:i:s" id="campaignEndDateInput" v-on:update:date-value="updateCampaignEndDate"
                />
              </div>
            </div>
            <b-card>
              <p>
                <b>Invoices Eligibility Conditions:</b>
              </p>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="invoiceStartDateInput" class="col-form-label">*Invoice Start Date:</label>
                  <DateTimePicker format="DD/MM/YYYY h:i:s" id="invoiceStartDateInput" v-on:update:date-value="updateInvoiceStartDate"
                    />
                </div>
                <div class="form-group col-md-6">
                  <label for="invoiceEndDateInput" class="col-form-label">*Invoice End Date:</label>
                  <DateTimePicker format="DD/MM/YYYY h:i:s" id="invoiceEndDateInput" v-on:update:date-value="updateInvoiceEndDate"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label for="minInvoicePriceInput" class="col-form-label">*Minimum Invoice Price Per Piece:</label>
                  <input type="text" class="form-control" id="minInvoicePriceInput" placeholder="Enter Price"
                    v-model="minimumInvoicePricePerPiece" required>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="eligibleOrderTypesInput" class="col-form-label">*Eligible Order Types:</label>
                  <ul class="list-group" id="eligibleOrderTypesInput">
                    <li class="list-group-item" v-for="item in availableOrderTypes" style="max-height:200px; overflow-y:auto">
                      <input type="checkbox" :name="item" :value="item" v-model="eligibleOrderTypes"/>
                      <span>{{item}}</span>
                    </li>
                  </ul>
                </div>
                <div class="form-group col-md-6">
                  <label for="eligibleLensDesignsInput" class="col-form-label">*Eligible Lens Designs:</label>
                  <ul class="list-group" id="eligibleLensDesignsInput" style="max-height:200px; overflow-y:auto">
                    <li class="list-group-item" v-for="item in availableLensDesigns">
                      <input type="checkbox" :name="item" :value="item" v-model="eligibleLenseDesigns"/>
                      <span>{{item}}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="eligibleLensIndexesInput" class="col-form-label">*Eligible Lens Indexes:</label>
                  <ul class="list-group" id="eligibleLensIndexesInput" style="max-height:200px; overflow-y:auto">
                    <li class="list-group-item" v-for="item in availableLensIndexes">
                      <input type="checkbox" :name="item" :value="item" v-model="eligibleLensIndexes"/>
                      <span>{{item}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </b-card>
            <button type="submit" class="btn btn-primary" @click="createCampaign()">Create</button>
          <!-- </form> -->
        <!-- </b-card> -->
      <!-- </b-collapse> -->

<!-- <p>
  <span>{{name}}</span><br/>
  <span>{{description}}</span><br/>
  <span>{{totalPrizeMoney}}</span><br/>
  <span>{{startDate}}</span><br/>
  <span>{{endDate}}</span><br/>
  <span>{{invoiceStartDate}}</span><br/>
  <span>{{invoiceEndDate}}</span><br/>
  <span>{{minimumInvoicePricePerPiece}}</span><br/>
  <span>avail ld: {{availableLensDesigns}}</span><br/>
  <span>avail ot: {{availableOrderTypes}}</span><br/>
  <span>ld: {{eligibleLenseDesigns}}</span><br/>
  <span>ot: {{eligibleOrderTypes}}</span><br/>
</p> -->

<!-- <span>rm5: {{rm5Amount}}</span>
<span>rm10: {{rm10Amount}}</span>
<span>rm20: {{rm20Amount}}</span>
<span>rm30: {{rm30Amount}}</span>
<span>rm50: {{rm50Amount}}</span>
<span>rm100: {{rm100Amount}}</span>
<br/>
<span v-for="item of customRMAmount">
  noteType: {{item.noteType}} , noteAmount: {{item.noteAmount}}
</span> -->

  <MyModal v-if="showModal" v-on:close="closeModal()" headerTitle="Creating..." bodyMessage="Please wait"/>

  <MyModal v-if="showCreateSuccessModal" v-on:close="closeSuccessModal()" headerTitle="Success" bodyMessage="Campaign created. Available at campaigns screen."/>
  <MyModal v-if="showCreateFailedModal" v-on:close="closeFailModal()" headerTitle="Failed" bodyMessage="Could not create the campaign, please try again."/>

  <MyModal v-if="showValidationModal" v-on:close="closeValidationModal()" headerTitle="Error" 
      v-bind:bodyMessage="validationMessage"/>

  </div>
</template>

<script>
import { DateTimePicker, MyModal } from '../components/'
export default {
  name: 'createcampaign',
  components: {
    DateTimePicker,
    MyModal
  },
  data () {
    return {}
  },
  created: function () {
    this.$store.dispatch('crtcammod/fetchAvailableOrderTypesFromFirestore')
    this.$store.dispatch('crtcammod/fetchAvailableLensDesignsFromFirestore')
    this.$store.dispatch('crtcammod/fetchAvailableLensIndexesFromFirestore')
  },
  methods: {
    createCampaign: function () {
      this.$store.dispatch('crtcammod/createCampaignInFirebase')
    },
    updateCampaignStartDate: function (dateString) {
      this.$store.commit('crtcammod/updateCampaignStartDate', dateString)
    },
    updateCampaignEndDate: function (dateString) {
      this.$store.commit('crtcammod/updateCampaignEndDate', dateString)
    },
    updateInvoiceStartDate: function (dateString) {
      this.$store.commit('crtcammod/updateInvoiceStartDate', dateString)
    },
    updateInvoiceEndDate: function (dateString) {
      this.$store.commit('crtcammod/updateInvoiceEndDate', dateString)
    },
    closeModal: function () {
      this.$store.commit('crtcammod/toggleShowModal', false)
    },
    closeSuccessModal: function () {
      this.$store.commit('crtcammod/toggleShowCreateSuccessModal', false)
    },
    closeFailModal: function () {
      this.$store.commit('crtcammod/toggleShowCreateFailedModal', false)
    },
    closeValidationModal: function () {
      this.$store.commit('crtcammod/toggleShowValidationModal', false)
    },
    addCustomNote: function () {
      this.$store.commit('crtcammod/addCustomNote')
    },
    removeCustomNote: function (index) {
      this.$store.commit('crtcammod/removeCustomNote', index)
    },
    updatedCustomNote: function () {
      console.log('updatedCustomNote')
      this.$store.commit('crtcammod/updatedCustomNote')
    },
    campaignBannerChanged: function (fileList) {
      let file = fileList && fileList.length > 0 ? fileList[0] : null
      this.$store.commit('crtcammod/updateCampaignBannerFile', file)
    }
  },
  computed: {
    showModal: function () {
      return this.$store.state.crtcammod.showModal
    },
    showCreateSuccessModal: function () {
      return this.$store.state.crtcammod.showCreateSuccessModal
    },
    showCreateFailedModal: function () {
      return this.$store.state.crtcammod.showCreateFailedModal
    },
    showValidationModal: function () {
      return this.$store.state.crtcammod.showValidationModal
    },
    availableLensDesigns: function () {
      return this.$store.state.crtcammod.availableLensDesigns
    },
    availableLensIndexes: function () {
      return this.$store.state.crtcammod.availableLensIndexes
    },
    availableOrderTypes: function () {
      return this.$store.state.crtcammod.availableOrderTypes
    },
    name: {
      get: function () {
        return this.$store.state.crtcammod.name
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateName', newValue)
      }
    },
    isDemo: {
      get: function () {
        return this.$store.state.crtcammod.isDemo
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/udpateIsDemo', newValue)
      }
    },
    description: {
      get: function () {
        return this.$store.state.crtcammod.description
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateDescription', newValue)
      }
    },
    totalPrizeMoney: {
      get: function () {
        return this.$store.state.crtcammod.totalPrizeMoney
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateTotalPrizeMoney', newValue)
      }
    },
    startDate: {
      get: function () {
        return this.$store.getters['crtcammod/getStartDate']
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateCampaignStartDate', newValue)
      }
    },
    endDate: {
      get: function () {
        return this.$store.getters['crtcammod/getEndDate']
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateCampaignEndDate', newValue)
      }
    },
    invoiceStartDate: {
      get: function () {
        return this.$store.getters['crtcammod/getInvoiceStartDate']
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateInvoiceStartDate', newValue)
      }
    },
    invoiceEndDate: {
      get: function () {
        return this.$store.getters['crtcammod/getInvoiceEndDate']
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateInvoiceEndDate', newValue)
      }
    },
    minimumInvoicePricePerPiece: {
      get: function () {
        return this.$store.state.crtcammod.minimumInvoicePricePerPiece
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateMinimumInvoicePrice', newValue)
      }
    },
    eligibleLenseDesigns: {
      get: function () {
        return this.$store.state.crtcammod.eligibleLenseDesigns
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateEligibleLenseDesigns', newValue)
      }
    },
    eligibleLensIndexes: {
      get: function () {
        return this.$store.state.crtcammod.eligibleLensIndexes
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateEligibleLensIndexes', newValue)
      }
    },
    eligibleOrderTypes: {
      get: function () {
        return this.$store.state.crtcammod.eligibleOrderTypes
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateEligibleOrderTypes', newValue)
      }
    },
    rm5Amount: {
      get: function () {
        return this.$store.state.crtcammod.rm5Amount
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateRm5Amount', newValue)
      }
    },
    rm10Amount: {
      get: function () {
        return this.$store.state.crtcammod.rm10Amount
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateRm10Amount', newValue)
      }
    },
    rm20Amount: {
      get: function () {
        return this.$store.state.crtcammod.rm20Amount
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateRm20Amount', newValue)
      }
    },
    rm30Amount: {
      get: function () {
        return this.$store.state.crtcammod.rm30Amount
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateRm30Amount', newValue)
      }
    },
    rm50Amount: {
      get: function () {
        return this.$store.state.crtcammod.rm50Amount
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateRm50Amount', newValue)
      }
    },
    rm100Amount: {
      get: function () {
        return this.$store.state.crtcammod.rm100Amount
      },
      set: function (newValue) {
        this.$store.commit('crtcammod/updateRm100Amount', newValue)
      }
    },
    sumOfAllNotes: {
      get: function () {
        return this.$store.state.crtcammod.sumOfAllNotes
      }
    },
    customRMAmount: {
      get: function () {
        return this.$store.state.crtcammod.customRMAmount
      }
    },
    validationMessage: {
      get: function () {
        return this.$store.state.crtcammod.validationMessage
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CreateCampaign.vue